import API  from "./api";

export const getMatches = (page, status = '', limit = 20) => {
    return API.get(`/matches?page=${page}&status=${status}&limit=${limit}`)
}

export const getUserCompletedMatches = (page = 1, limit = 10) => {
    return API.get(`/matches/my-completed?page=${page}&limit=${limit}`)
}